// Design tokens — source of truth: app/mocki-stitch/.../warm_trust_fintech/DESIGN.md
// Polfinance brand: primary #0093E5, navy #034E6F. Buttons are ALWAYS solid filled.

export const colors = {
  background: '#F8F9FF',
  surface: '#F8FAFC',
  card: '#FFFFFF',
  primary: '#0093E5',
  primaryPressed: '#007ABF',
  navy: '#034E6F',
  textPrimary: '#0D1C2E',
  textSecondary: '#3F4851',
  outline: '#6F7883',
  outlineVariant: '#BFC7D3',
  divider: '#F1F5F9',
  disabledBg: '#E2E8F0',
  disabledText: '#94A3B8',
  success: '#16A34A',
  successBg: 'rgba(22,163,74,0.10)',
  warning: '#D97706',
  warningBg: 'rgba(217,119,6,0.10)',
  error: '#BA1A1A',
  errorBg: 'rgba(186,26,26,0.10)',
  info: '#0093E5',
  infoBg: 'rgba(0,147,229,0.10)',
  primaryTile: '#DCE9FF', // light-blue icon tiles / active tab pill
} as const;

export const spacing = {
  base: 4,
  xs: 8,
  sm: 12,
  md: 16,
  lg: 24,
  xl: 32,
  screen: 20, // safe left/right margin
} as const;

export const radius = {
  chip: 8,
  button: 12,
  card: 16,
  sheet: 24,
  full: 9999,
} as const;

// Soft ambient navy shadow — the "pillow" card effect
export const shadows = {
  card: {
    shadowColor: '#034E6F',
    shadowOpacity: 0.06,
    shadowRadius: 16,
    shadowOffset: { width: 0, height: 4 },
    elevation: 3,
  },
} as const;

export const fonts = {
  medium: 'Quicksand_500Medium',
  semiBold: 'Quicksand_600SemiBold',
  bold: 'Quicksand_700Bold',
} as const;

export const type = {
  headlineLg: { fontFamily: fonts.bold, fontSize: 28, lineHeight: 34, letterSpacing: -0.56, color: colors.textPrimary },
  headlineMd: { fontFamily: fonts.bold, fontSize: 22, lineHeight: 28, letterSpacing: -0.22, color: colors.textPrimary },
  headlineSm: { fontFamily: fonts.semiBold, fontSize: 18, lineHeight: 24, color: colors.textPrimary },
  bodyLg: { fontFamily: fonts.medium, fontSize: 16, lineHeight: 24, color: colors.textPrimary },
  bodyMd: { fontFamily: fonts.medium, fontSize: 14, lineHeight: 20, color: colors.textSecondary },
  labelLg: { fontFamily: fonts.bold, fontSize: 14, lineHeight: 18, color: colors.textPrimary },
  labelMd: { fontFamily: fonts.semiBold, fontSize: 12, lineHeight: 16, color: colors.textSecondary },
} as const;
